// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__1jnMK","imageUploader":"EGiftCard_imageUploader__3VNAp"};